import { isArray } from 'lodash';
import { Calendar, Clock, MapPin } from 'lucide-react';
import React from 'react';
import { formatDateDDMMYYYDotted } from '../../../app/utils/date';
import { formatOpportunitySalary } from '../../layout/opportunity/OpportunityUtils';
import { messageCardUtil } from './MatchBody';
import { formatDaysLeftToApply } from './utils/formatDaysLeftToApply';
import { MatchMessageCardflagLabel } from './utils/matchMessageCardflagLabel';
interface OpportunityMessageCardProps extends React.HTMLAttributes<HTMLDivElement> {
  content: any;
}

const OpportunityMessageCard = ({ content }: OpportunityMessageCardProps) => {
  const options: any = {};
  options.pills = [];
  options.subHeader;

  const salary = formatOpportunitySalary(content).display;
  const location = content.location;
  const employmentType = content.employmentType;
  const daysLeftToApply = formatDaysLeftToApply(content.applicationDeadline);
  const info = MatchMessageCardflagLabel(daysLeftToApply, <Calendar />);

  const startDate = isArray(content?.opportunityStartDate)
    ? content?.opportunityStartDate.map((date: any) => formatDateDDMMYYYDotted(date))
    : typeof content?.opportunityStartDate === 'string'
      ? [formatDateDDMMYYYDotted(content?.opportunityStartDate)]
      : null;

  if (content.applicationDeadline) {
    options.subHeader = info;
  }

  if (salary !== '') {
    options.pills.push({
      icon: '',
      text: salary
    });
  }

  if (location !== '') {
    options.pills.push({
      icon: <MapPin />,
      text: location
    });
  }

  if (employmentType !== '') {
    options.pills.push({
      icon: <Clock />,
      text: employmentType
    });
  }

  if (startDate && startDate?.length > 0) {
    startDate.map((sd: any) => {
      options.pills.push({
        icon: <Calendar />,
        text: `start: ${sd}`
      });
    });
  }

  options.entityColor = 'mint-700';
  options.entityName = content.opportunityType;

  return messageCardUtil({ content, options });
};

export default OpportunityMessageCard;
